import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import { EMAIL_RULE, CREATENEW, CANCEL, ENABLE, DISABLE, EMAIL_RULE_LIST } from "../../../../shared/constants/Constants";
import DefaultButton from "../../../../shared/components/DefaultButton";
import ListView from "../../../../shared/components/listview/ListView";
import Modalpopup from "../../../../shared/components/Modalpopup";
import { loadEmailRuleTicketDataRequest, loadEmailRuleDeleteDataRequest, ResetEmailRuleDeleteDataReset } from "../redux/Actions";
import { loadCompanyDataRequest } from "../../../company/redux/Actions"; 
import dropdownFilterFunction from "../../../../shared/components/listview/dropdownFilterFunction";


const EmailRuleList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const { emailrulelist, deleteSuccess  } = useSelector((state) => state.EmailRule);
    const { companies } = useSelector((state) => state.company);

  console.log("List data", emailrulelist);

  useEffect(() => {
    dispatch(loadEmailRuleTicketDataRequest());
    dispatch(loadCompanyDataRequest()); 
  }, [dispatch]);

    // Company dropdown options  -- add this block
    const companyOptions = useMemo(() => {
      if (!companies) return [];
      return companies.map(c => ({ value: c.id, label: c.company_name }));
    }, [companies]);

    const companyFilterFunc = dropdownFilterFunction(companyOptions);

  // Handle Edit
  const handleEdit = (row) => {
    navigate(`/emailruleform/${row.id}`);
  };

  // Handle Status - Open Modal
  const handleStatusClick = (row) => {
    setSelectedRow(row);
    setShowStatusModal(true);
  };

  // Confirm Status Change
  const handleStatus = (row) => {
    if (row?.id) {
      // Dispatch your status update action here
      dispatch(loadEmailRuleDeleteDataRequest(row.id));
      console.log("Status change for:", row);
      setShowStatusModal(false);
      setSelectedRow(null);
    }
  };
  //Reload after status change 
  useEffect(() => {
    if (deleteSuccess) {
      dispatch(loadEmailRuleTicketDataRequest()); // reload list
      dispatch(ResetEmailRuleDeleteDataReset());  // reset flag
    }
  }, [deleteSuccess, dispatch]);

  // Format conditions for display
  const formatConditions = (conditions) => {
    if (!conditions || !conditions.groups || conditions.groups.length === 0) {
      return "No conditions";
    }

    let conditionsText = [];
    conditions.groups.forEach((group, groupIndex) => {
      if (group.conditions && group.conditions.length > 0) {
        const groupConditions = group.conditions.map(cond => 
          `${cond.field} ${cond.operator} "${cond.value}"`
        ).join(` ${group.logic} `);
        conditionsText.push(groupConditions);
      }
    });

    return conditionsText.length > 0 ? conditionsText.join(" | ") : "No conditions";
  };

  // Map is_active to status for the shared ListView component
    const transformedRowData = (emailrulelist?.data || []).map(row => ({
    ...row,
    status: row.is_active // Map is_active to status
    }));  

  // Define columns for ListView (AG Grid format)
  const columnNames = [
    {
      field: "id",
      display_name: "ID",
      type: "text",
      sort: null,
      width: 80,
      hide: true, 
    },
    {
      field: "actions",
      display_name: "Actions",
      type: "actions",
      width: 120,
      pinned: "left",
    },
    {
      field: "rule_name",
      display_name: "Rule Name",
      type: "text",
      sort: null,
      width: 250,
      pinned: true,
    },
    {
      field: "ruleDescription",
      display_name: "Rule Description",
      type: "text",
      sort: null,
      width: 1000,
      flex: 1, // This allows it to take remaining space
    },  
    {
      field: "company_name",
      display_name: "Company",
      type: "dropdown",         
      sort: null,
      width: 250,
      dropdownOptions: companyOptions.map(option => option.label),  
      dropdownFunction: companyFilterFunc,                           
    },  
    {
      field: "stop_processing",
      display_name: "Stop Processing",
      type: "customBadge",
      sort: null,
      width: 150,
    },    
  ];

  return (
    <>
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs
            children={[
              {
                href: "/emailrulelist/",
                label: EMAIL_RULE_LIST,
              },
            ]}
          />
        </Col>
        <Col>
          <div className="float-end">
            <Link to="/emailruleform/add">
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={CREATENEW}
              />
            </Link>
          </div>
        </Col>
      </Row>

      <Card className="mt-3">
        <Card.Body>
          <ListView
            columnNames={columnNames}
            rowData={transformedRowData}
            exportTitle="Email_Rules"
            clickEdit={handleEdit}
            clickStatus={handleStatusClick}
            tableHeight="65vh"
            shouldSetNextPrevIds={false}
          />
        </Card.Body>
      </Card>

      {/* Status Change Confirmation Modal */}
      <Modalpopup 
        height="auto" 
        size="md" 
        show={showStatusModal} 
        handleClose={() => setShowStatusModal(false)} 
        actionTitle="Email Rule Status"
      >
        <p>
          {selectedRow?.is_active
            ? <>Do you want to Disable <strong>{selectedRow?.rule_name}</strong>?</>
            : <>Do you want to Enable <strong>{selectedRow?.rule_name}</strong>?</>
          }
        </p>

        <div className="col-md-12">
          <DefaultButton
            buttonClass="btn btn-secondary me-2"
            buttonTitle={CANCEL}
            actionBlock={() => setShowStatusModal(false)}
          />
          <DefaultButton
            buttonClass={selectedRow?.is_active ? "btn btn-danger" : "btn btn-success"}
            buttonTitle={selectedRow?.is_active ? DISABLE : ENABLE}
            actionBlock={() => handleStatus(selectedRow)}
          />
        </div>
      </Modalpopup>
    </>
  );
};

export default EmailRuleList;